<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="$store.state.sidebarOpened = false" v-if="$store.state.sidebarOpened"></div>
        <transition name="slide">
            <div v-if="$store.state.sidebarOpened" class="sidebar-panel">
                <div class="close" @click="$store.state.sidebarOpened = false">
                   <i class="icon-cross"></i>
                </div>
                <div class="row">
                  <ul class="mobil-nav " v-scroll-spy-active="{class: 'custom-active'}" v-scroll-spy-link>
                    <li class=" login-link mr-1 pb-1 menu-link ">               
                      <a class="nav-link" v-scroll-to="'#tenders'" >{{ $t('pages.tenders')}}</a>                
                    </li>
                    <li class="  login-link mr-1 pb-1 menu-link ">   
                      <a class="nav-link" v-scroll-to="'#about'">{{ $t('pages.about')}}</a>              
                    </li>
                    <li class=" login-link pb-1 menu-link ">
                      <a class="nav-link" v-scroll-to="'#contact'" >{{ $t('pages.contacts')}}</a> 
                    </li>
                  </ul>
                </div>
                <slot></slot>
            </div>
        </transition>
    </div>
</template>
<script>

    export default {
      name: "Sidebar",
      data() {
        return {
          isPanelOpen:true
        }
      },
      methods: {
        
      },
      computed:{
        
         
      },
      mounted(){
               
      },
      created(){
        
      }
    }

</script>
<style >
.sidebar {
  position: absolute;
}
 .slide-enter-active,
    .slide-leave-active
    {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
        transition: all 150ms ease-in 0s
    }

    .sidebar-backdrop {
        /* background-color: rgba(182, 182, 182, 0.5); */
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
    }

    .sidebar-panel {
        overflow-y: auto;
        background-color: #E5E5DB;
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        z-index: 999;
        padding: 3rem 20px 2rem 20px;
        width: 300px;
    }
    .close {
      opacity: 1;
    }
    .close i {
      color: #fff;
      }
    .mobil-nav {
      padding: 10px 20px;
    }
    .mobil-nav li {
      list-style: none;
    }
    .nav-link {
      font-size: 16px;
      text-transform: uppercase;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/menu/SidebarFront.vue